import { render, staticRenderFns } from "./judgement-deeds-inquiry.vue?vue&type=template&id=2e7902b7&"
import script from "./judgement-deeds-inquiry.vue?vue&type=script&lang=js&"
export * from "./judgement-deeds-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports